import { erpAxios } from '.';

const getCosts = async (kreditBroj) => {
  const { data } = await erpAxios.get(`/costsAndDates/getCosts/${kreditBroj}`);
  return data;
};

export default getCosts;
